import { useCallback, useState } from 'react';

/**
 * Whether a `<video>` has a decoded frame to show (VID-502). A stream being
 * attached doesn't mean it has pixels yet, so a tile holds its avatar until
 * this is true instead of flashing a black rectangle.
 *
 * Pass `onLoadedData` to the `<video>`: `loadeddata` (readyState
 * HAVE_CURRENT_DATA) is the earliest point a frame is guaranteed decoded, so
 * it reveals sooner than waiting for `playing`. Call `resetVisibleFrame`
 * whenever the element's `srcObject` changes, so the next stream waits for
 * its own first frame.
 */
const useVideoFrameReady = () => {
    const [hasVisibleFrame, setHasVisibleFrame] = useState(false);

    const onLoadedData = useCallback(() => {
        setHasVisibleFrame(true);
    }, []);

    const resetVisibleFrame = useCallback(() => {
        setHasVisibleFrame(false);
    }, []);

    return { hasVisibleFrame, onLoadedData, resetVisibleFrame };
};

export default useVideoFrameReady;
